import { t } from 'i18next';
import React from 'react';
import { useAppFont } from 'utils/helper/useAppFont';

const SearchEmptyPage = ({ searchText }) => {
  const { interClass, headingClass, interFamily, headingFamily}= useAppFont();
  return (
    <>
      <div className="flex flex-col items-start px-4 sm:px-8 md:px-[104px] gap-6 md:gap-10 w-full">
        
        <div className="flex flex-col justify-center items-center py-8 gap-6 w-full">
            <img
              src="/images/searchImg.png"
              alt="No Results"
              className="w-[248px] h-[248px] object-cover"
            />
        </div>

        <div className="flex flex-col items-center gap-6 md:gap-8 w-full">
          <div className="flex flex-col justify-center items-center gap-6 md:gap-8 w-full">
            
            {searchText && (
              <div
                className="text-center p-1 rounded-full"
                style={{ borderColor: '#D4764A', backgroundColor: '#FFFFFF' }}
              >
                <span
                  className={`text-[14px] md:text-base font-normal ${interClass}`}
                  style={{ color: '#D4764A' }}
                >
                  "{searchText}"
                </span>
              </div>
            )}
            <div className="flex flex-col items-center gap-4 max-w-2xl w-[50%]">
              <span className={`text-[32px] sm:text-2xl md:text-[32px] font-semibold text-[#1A1A1A] text-center leading-[48px] ${headingClass}`}>
                {t("oopsWeCouldNotFindThatCake")}
              </span>
              
              <div className="text-center">
                <p className={`text-[20px] sm:text-lg md:text-[20px] text-[#727783] leading-[28px] font-normal ${interClass}`}>
                  {t("weCouldNotFoundAnyCackesMatchingYourSearch")}
                </p>
                <p className={`text-[20px] sm:text-lg md:text-[20px] text-[#727783] leading-[28px] font-normal ${interClass}`}>
                  {t("tryDifferentKeywordsOrBrowseAllCakes")}
                </p>
              </div>
            </div>

          </div>
        </div>

        <div className="flex flex-row sm:flex-col gap-4 items-center justify-center w-full pb-8 md:pb-12">
          <button 
            className={`px-8 md:px-10 py-3 text-sm md:text-[16px] font-medium text-[#1A1A1A] bg-white border-2 border-gray-300 rounded-full hover:bg-[#FEFBFC] transition-colors w-auto sm:w-auto min-w-[160px] text-center leading-[24px] ${headingClass}`}
            onClick={() => console.log('Clear search')}
          >
            {t("clearSearch")}
          </button>
          <button 
            className={`px-8 md:px-10 py-3 text-sm md:text-[16px] font-medium text-[#FFFFFF] bg-white border-2 border-gray-300 rounded-full hover:bg-gray-50 transition-colors w-auto sm:w-auto min-w-[160px] text-center leading-[24px] ${headingClass}`}
            style={{ backgroundColor: '#8B1538' }}
            onClick={() => console.log('Browse cakes')}
          >
            {t("browseCakes")}
          </button>
        </div>

      </div>
    </>
  );
};

export default SearchEmptyPage;